var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcMyLocation = function SvgIcMyLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "#9499A5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#9499A5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9499A5",
    d: "M11.25 5a.75.75 0 0 0 1.5 0zm0-3v3h1.5V2zM12.75 19a.75.75 0 0 0-1.5 0zm-1.5 0v3h1.5v-3zM5 12.75a.75.75 0 0 0 0-1.5zm-3 0h3v-1.5H2zM19 11.25a.75.75 0 0 0 0 1.5zm0 1.5h3v-1.5h-3z"
  })));
};
export default SvgIcMyLocation;